import React from 'react'
import { useFormContext } from 'react-hook-form'
import * as changeCase from 'change-case'

const FormErrors = () => {
    const {formState} = useFormContext()
    if (!formState.errors?.length) return null
    return (
        <div className="p-2 border-2 border-red-500 rounded-md text-red-500">
            {Object.values(formState.errors).map((error, i) =>
                error && typeof error === "object" && "message" in error && error.message
                    ? <p key={i}>{changeCase.sentenceCase(error.message as string)}</p>
                    : null
            )}
        </div>
    )
  return (
    <div>FormErrors</div>
  )
}

export default FormErrors